import React from 'react';
import { Link } from 'react-router-dom';
import 'AppSrc/core/style/components/page-error-screen/page-error-screen.css';
import PropTypes from 'prop-types';

const MESSAGES_FOR_ERROR_TYPE = {
  notFound: 'The page you are trying to reach does not exist.',
  unauthorised: 'You are not authorised to view this page',
};

const PageErrorScreen = ({ errorType = 'notFound' }) => (
  <div className="page-error-screen">
    <div className="page-error-content">
      <p className="page-error-message">{ MESSAGES_FOR_ERROR_TYPE[errorType] }</p>
      <div className="home-link-wrapper">
        <Link
          className="home-link"
          to="/"
        >
          <p>Go back to homepage</p>
        </Link>
      </div>
    </div>
  </div>
);

PageErrorScreen.propTypes = {
  errorType: PropTypes.string,
};

export { PageErrorScreen };
